import { Loader } from "sui";
import { z } from "zod";

import { i18n } from "@lib/i18n";
import { queries } from "@lib/queries";
import { globalLayoutRoute } from "@routes";
import { requireScope } from "@routes/authorization";
import { createRoute, lazyRouteComponent, Outlet, redirect } from "@tanstack/react-router";

export const tasksRoute = createRoute({
    getParentRoute: () => globalLayoutRoute,
    path: `tasks`,
    component: Outlet,
    beforeLoad: () => {
        requireScope("account");
        return { getTitle: () => i18n.doc_title_tasks() };
    },
});
export const tasksRouteLayout = createRoute({
    id: `tasksLayout`,
    getParentRoute: () => tasksRoute,
    component: lazyRouteComponent(() => import("./index")),
});
export const tasksListIndexRoute = createRoute({
    getParentRoute: () => tasksRouteLayout,
    path: `/`,
    beforeLoad: () => {
        throw redirect({ to: `/tasks/all` });
    },
});
export const tasksListHomeRoute = createRoute({
    getParentRoute: () => tasksRouteLayout,
    path: `all`,
    component: lazyRouteComponent(() => import("./containers/TasksListHome")),
});
const tasksListStatusSearchSchema = z
    .object({
        page: z.number().catch(1),
    })
    .partial();

type TaskListStatusSearch = z.infer<typeof tasksListStatusSearchSchema>;
export const tasksListStatusRoute = createRoute({
    getParentRoute: () => tasksRouteLayout,
    path: `$status`,
    validateSearch: (search: TaskListStatusSearch) => tasksListStatusSearchSchema.parse(search),
    component: lazyRouteComponent(() => import("./containers/TasksListStatus")),
});

const taskViewRouteSearchSchema = z.object({
    origin: z.string().optional(),
});
export const taskViewRoute = createRoute({
    getParentRoute: () => tasksRoute,
    path: `view/$taskId`,
    validateSearch: taskViewRouteSearchSchema,
    loader: async (opts) => {
        // Don't render the route at all until the user is loaded because feature flag depends on user data
        await opts.context.queryClient.ensureQueryData(queries.user.detail());
    },
    component: lazyRouteComponent(() => import("./components/TaskView")),
    beforeLoad: () => requireScope("account"),
    pendingComponent: () => (
        <div className='grid h-full w-full place-items-center text-blue-500'>
            <Loader />
        </div>
    ),
});
